import React from 'react';
import { connect } from 'react-redux';
import ReactTable from "react-table";
import { TableConfig } from '../../utils/appConfig';
import Pagination from '../page/Pagination';
import NoData from '../page/NoData';
import LANGUAGES_CONTROLLER from '../../controllers/languages';
import PROCESSING_STATS_CONTROLLER from '../../controllers/processingStats';
import ApplicationMessages from '../inAppMessages/ApplicationMessages';
import Logger, {LOG_LEVELS}  from '../../utils/log';
import MessageLogger, { ALL_MESSAGES } from '../../utils/logger';

const log = new Logger('ProcessingStatsDetails', LOG_LEVELS.DEBUG);
const messageLog = new MessageLogger('ProcessingStatsDetails', LOG_LEVELS.DEBUG);

const NoDataComponent = props => (
    <NoData
        noDataText="ProcessingStatsDetails_NoData"
        {...props}
    />
);

export class ProcessingStatsDetails extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            pagination: {
                page: 0,
                startAt: 1,
                pageSize: TableConfig.STANDARD_LEVEL_TWO_PAGE_SIZE
            }
        };
        this.onFetchData = this.onFetchData.bind(this);
    }

    componentDidUpdate(prevProps) {
        log.debug('componentDidUpdate()');
        if(prevProps.processingStatsDetails !== this.props.processingStatsDetails) {
            const transactionsOnHoldCount = this.props.processingStatsDetails ? this.props.processingStatsDetails.transactionsOnHold : 0;
            if(transactionsOnHoldCount > 0) {
                messageLog.clearDictionaryError(ALL_MESSAGES.ALL_TRANSACTIONS_PROCESSED);                
                messageLog.clearDictionaryError(ALL_MESSAGES.DOCUMENTS_IN_PROCESSING);
                messageLog.setDictionaryMessage(ALL_MESSAGES.DOCUMENTS_IN_PROCESSING, transactionsOnHoldCount);
            } else {
                messageLog.clearDictionaryError(ALL_MESSAGES.DOCUMENTS_IN_PROCESSING);
                messageLog.setDictionaryMessage(ALL_MESSAGES.ALL_TRANSACTIONS_PROCESSED);
            }
        }
    }

    onFetchData(state) {
        log.debug('onFetchData(): state: ', state);
        let { page, pageSize } = state;
        page = Object.is(page, NaN) ? 0 : page;
        pageSize = Object.is(pageSize, NaN) ? TableConfig.PAGINATION.STANDARD_LEVEL_TWO_PAGE_SIZE : pageSize;
        const startAt = page > 0 ? (page * pageSize) + 1: 1;
        let pagination = Object.assign({}, this.state.pagination,  {
            page: page,
            startAt: startAt,
            pageSize: pageSize
        });
        this.setState({
            pagination: pagination
        });
        this.props.getProcessingStatsDetails({
            startAt: pagination.startAt,
            count: pageSize
        });
    }

    render() {
        log.debug('render():');
        const processingStatsDetails = this.props.processingStatsDetails ? this.props.processingStatsDetails : {};
        const transactionsOnHoldInvoiceNumbers = Array.isArray(processingStatsDetails.transactionsOnHoldInvoiceNumbers) 
            ? processingStatsDetails.transactionsOnHoldInvoiceNumbers.map( _ => ({"invoiceNumber" : _ })) : [];
        
        //Table setup
        const defaultColumns = [
            { 
                Header: props => (
                    <span>{LANGUAGES_CONTROLLER.format(this.props.languages, 'ProcessingStats_InvoiceNumber')}</span>
                ), 
                accessor: 'invoiceNumber', 
                sortable:false, 
                filterable: false, 
                minWidth: 150
            }
        ];
        const cols = Array.isArray(this.props.cols) ? this.props.cols : defaultColumns;
        //Pagination data        
        const pagination = this.state.pagination || {};
        const pageSize = pagination.pageSize || this.props.defaultPageSize  || TableConfig.PAGINATION.STANDARD_LEVEL_TWO_PAGE_SIZE;        
        const transactionsOnHoldCount = processingStatsDetails.transactionsOnHold || 0;
        //This will avoid modal height change while using prev and next
        const noDataComponent =  transactionsOnHoldCount === 0 ? NoDataComponent: (<span></span>);
        const pages  =Math.ceil(transactionsOnHoldCount / pageSize);        
        if(this.viewTable) {
            //If page count is reduced, we need to set the page number correctly or show no data found
            if(pages === 0 && this.viewTable.state.pages !== 0 ) {
                return (
                    <div>
                        <ApplicationMessages
                            messageType="applicationInfo" 
                            messageIds={[ALL_MESSAGES.ALL_TRANSACTIONS_PROCESSED]} 
                        ></ApplicationMessages>
                        <NoDataComponent />
                    </div>
                );
            } else if(this.viewTable.state.pages > pages && this.viewTable.state.page > pages - 1 ) {
                //Set to the last page
                this.viewTable.state.page = pages - 1;
            } 
        }
        
        return (
            <div data-test ="component-processing-stats-details">
                <ApplicationMessages
                    messageType="applicationInfo" 
                    messageIds={[ALL_MESSAGES.DOCUMENTS_IN_PROCESSING]} 
                    tooltipWithParams={false} 
                ></ApplicationMessages>  
                <ReactTable
                    manual
                    ref={ eleRef => this.viewTable = eleRef}
                    data={transactionsOnHoldInvoiceNumbers}
                    columns={cols}                    
                    minRows={pageSize}
                    maxRows={0}
                    PaginationComponent={Pagination}
                    pages={pages}
                    defaultPageSize={pageSize}
                    loading={this.props.loading} 
                    onFetchData={this.onFetchData} // Request new data when things change
                    showPageJump={true}
                    pageSizeOptions={TableConfig.PAGINATION.STANDARD_PAGE_SIZE_OPTIONS}
                    noDataText=""
                    NoDataComponent={noDataComponent}
                    {...this.props.tableOptions}
                />
            </div>
        );
    }
}


ProcessingStatsDetails.defaultProps = {
    tableOptions: {}
};

function mapStateToProps(state) {
    return {
        processingStatsDetails: state.processingStats && state.processingStats.processingStatsDetails   
    };
}

function mapDispatcherToProps(dispatch) {
    return {
        getProcessingStatsDetails: (paginationOptions) => {
            dispatch(PROCESSING_STATS_CONTROLLER
                .doGetProcessingStatsDetails(paginationOptions));
        }
    }
}

export default connect(mapStateToProps, mapDispatcherToProps)(ProcessingStatsDetails);
